import { Routes } from '@angular/router';
import { ConsultationComponent } from './main/pages/consultation/consultation.component';
import { AuthGuard } from './auth.guard';
import { UserListComponent } from './main/pages/users/user-list/user-list.component';
import { ConsultationListComponent } from './main/pages/consultation/consultation-list/consultation-list.component';
import { ApsComponent } from './main/pages/consultation/aps/aps.component';
import { ConsultationDetailComponent } from './main/pages/consultation/consultation-detail/consultation-detail.component';
import { CreateEditUserComponent } from './main/pages/users/create-edit-user/create-edit-user.component';
import { PatientListComponent } from './main/pages/patient/patient-list/patient-list.component';
import { PatientDetailComponent } from './main/pages/patient/patient-detail/patient-detail.component';
import { PatientCaseCardComponent } from './main/pages/patient/patient-case-card/patient-case-card.component';
import { ProfileComponent } from './main/pages/profile/profile.component';
import { AnalysisReportListComponent } from './main/pages/analysis-report-list/analysis-report-list.component';
import { DermotologistReportListComponent } from './main/pages/dermotologist-report-list/dermotologist-report-list.component';
import { BranchReportListComponent } from './main/pages/branch-report-list/branch-report-list.component';
import { LoginComponent } from './main/pages/login/login.component';
import { ResetPasswordComponent } from './main/pages/reset-password/reset-password.component';
import { ForgotPasswordComponent } from './main/pages/forgot-password/forgot-password.component';
import { DashboardMainComponent } from './main/pages/dashboard/dashboard-main/dashboard-main.component';
import { ReferralComponent } from './main/pages/referral/referral.component';
import { AppointmentListComponent } from './main/pages/appointment/appointment-list/appointment-list.component';
import { InvoiceComponent } from './main/pages/invoice/invoice.component';
import { DermAiListComponent } from './main/pages/dermai/derm-ai-list/derm-ai-list.component';
import { DermAiConsultationComponent } from './main/pages/dermai/derm-ai-consultation/derm-ai-consultation.component';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  {
    path: 'dashboard',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'main', component: DashboardMainComponent },
      { path: '**', redirectTo: 'main' },
    ],
  },
  {
    path: 'user',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'list', component: UserListComponent },
      { path: 'create', component: CreateEditUserComponent },
      { path: 'edit/:id', component: CreateEditUserComponent },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'consultation',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'list', component: ConsultationListComponent },
      { path: 'detail/:id', component: ConsultationDetailComponent },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'patient',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'list', component: PatientListComponent },
      { path: 'a-p-s', component: ApsComponent },
      { path: 'detail/:id', component: PatientDetailComponent },
      {
        path: 'appointment-detail/:id/:appointmentId',
        component: PatientDetailComponent,
      },
      {
        path: 'details/:id/:recordId/:caseId',
        component: PatientDetailComponent,
      },
      {
        path: 'new-patient-case-card/:id',
        component: PatientCaseCardComponent,
      },
      {
        path: 'new-patient-case-card-appointment/:id/:appointmentId',
        component: PatientCaseCardComponent,
      },
      {
        path: 'appointment-detail/:id',
        component: PatientCaseCardComponent,
      },
      {
        path: 'add-patient-case-card/:patientId/:caseId',
        component: PatientCaseCardComponent,
      },
      {
        path: 'add-patient-case-card-appointment/:patientId/:caseId/:appointmentId',
        component: PatientCaseCardComponent,
      },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'appointment',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'list', component: AppointmentListComponent },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'dermoscan',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'list', component: DermAiListComponent },
      { path: 'dermconsultation/:id', component: DermAiConsultationComponent },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'referral',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'list', component: ReferralComponent },
      { path: 'detail/:id', component: ConsultationDetailComponent },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'invoice',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'list', component: InvoiceComponent },
      { path: '**', redirectTo: 'list' },
    ],
  },
  {
    path: 'profile',
    component: ConsultationComponent,
    children: [
      { path: 'detail', component: ProfileComponent },
      { path: 'info', component: ProfileComponent },
    ],
  },
  {
    path: 'report',
    component: ConsultationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'analysis-report', component: AnalysisReportListComponent },
      {
        path: 'dermotologist-report',
        component: DermotologistReportListComponent,
      },
      { path: 'branch-report', component: BranchReportListComponent },
    ],
  },
  { path: '**', redirectTo: '/dashboard' },
];
